import { DouyinInfluencerProfile, DouyinInfluencers } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSelectSocialAccountsForPackage } from './hooks';

export const DouyinPackageInfluencersSearch = () => {
  const { getCurrentProfiles, getSortSelectButtonProps, getListSelectButtonProps } =
    useSelectSocialAccountsForPackage<DouyinInfluencerProfile>({ socialMedia: InfluencersTabType.DOUYIN });

  return (
    <DouyinInfluencers
      isPackagePage
      getCurrentProfiles={getCurrentProfiles}
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
